import whenDomReady from 'when-dom-ready';

let prevScrollY = 0;
const startHeight = window.innerHeight / 1.2;

const ACTIVE_CLASS = 'is-active';
const VISIBLE_CLASS = 'is-visible';

function initialise() {
  const containers = Array.from(document.querySelectorAll('.js-ds-sections'));

  containers.forEach(initialiseContainer);
}

/**
 * Initialise navigation.
 * @param {HTMLElement} container
 */
function initialiseContainer(container) {
  const navigation = container.querySelector('.js-ds-sections-nav');
  const scrollTop = container.querySelector('.js-ds-sections-scroll-top');

  if (navigation) {
    const sections = container.querySelectorAll('[id][data-section-name]');

    const navSelectedDiv = document.createElement('div');
    navSelectedDiv.classList.add('ds-nav-selected', 'js-ds-nav-selected');
    for (let i = 0; i < sections.length; i += 1) {
      navSelectedDiv.innerText = sections[0].getAttribute('data-section-name').toUpperCase();
    }
    navSelectedDiv.addEventListener('click', handleSelectedClick);

    navigation.before(navSelectedDiv);

    if (sections && sections.length) {
      for (let i = 0; i < sections.length; i += 1) {
        const section = sections[i];

        const navItemDiv = document.createElement('div');
        navItemDiv.classList.add('ds-nav-sticky__item');

        const navItemLink = document.createElement('a');
        navItemLink.classList.add('ds-nav-sticky__link');
        navItemLink.classList.add('js-ds-sections-nav-link');
        navItemLink.innerText = section.dataset.sectionName;
        navItemLink.href = `#${section.id}`;
        navItemLink.addEventListener('click', handleClick);

        navItemDiv.appendChild(navItemLink);
        navigation.appendChild(navItemDiv);
      }
    }
  }

  if (scrollTop) {
    scrollTop.addEventListener('click', event => {
      event.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    window.addEventListener('scroll', handleScroll);
  }

  const sections = Array.from(container.querySelectorAll('.ds-section')).filter(
    section => section.id,
  );

  if (sections && sections.length) {
    const observer = new IntersectionObserver(handleIntersection, {
      // Wait until elements intersect the midpoint of the screen
      rootMargin: '-50%',
    });

    sections.forEach(section => {
      observer.observe(section);
    });
  }

  /**
   * Handle navigation item click.
   * @param {Event} event
   */
  function handleClick(event) {
    event.preventDefault();

    const href = event.currentTarget.getAttribute('href').substring(1);

    const scrollToElement = document.getElementById(href);

    const navSelectedTrigger = document.querySelector('.js-ds-nav-selected');

    if (!scrollToElement) {
      return;
    }

    if (navSelectedTrigger && navSelectedTrigger.classList.contains(ACTIVE_CLASS)) {
      navSelectedTrigger.classList.remove(ACTIVE_CLASS);
    }

    scrollToElement.scrollIntoView({
      behavior: 'smooth',
    });
  }

  /**
   * Handle selected click.
   * @param {Event} event
   */
  function handleSelectedClick(event) {
    event.preventDefault();

    event.currentTarget.classList.toggle(ACTIVE_CLASS);
  }

  /**
   * Handle intersections.
   * @param {[IntersectionObserverEntry]} entries
   */
  function handleIntersection(entries) {
    const intersectingEntry = entries.find(entry => entry.isIntersecting);

    // Don't need to act on something leaving, only entering.
    if (!intersectingEntry) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('Intersection:', intersectingEntry.target.id, intersectingEntry);
    }

    const navLinks = Array.from(navigation.querySelectorAll('.js-ds-sections-nav-link'));
    const navSelectedTrigger = document.querySelector('.js-ds-nav-selected');

    navLinks.forEach(navLink => {
      const navItem = navLink.parentElement;

      if (navLink.getAttribute('href') === `#${intersectingEntry.target.id}`) {
        if (navSelectedTrigger) {
          navSelectedTrigger.innerText = navLink.innerText;
        }

        navItem.classList.add(ACTIVE_CLASS);
      } else {
        navItem.classList.remove(ACTIVE_CLASS);
      }
    });
  }

  function handleScroll() {
    const y = window.scrollY;

    if (y > prevScrollY) {
      scrollTop.parentElement.classList.remove(VISIBLE_CLASS);
    }

    if (y < prevScrollY && y > startHeight) {
      scrollTop.parentElement.classList.add(VISIBLE_CLASS);
    } else {
      scrollTop.parentElement.classList.remove(VISIBLE_CLASS);
    }
    prevScrollY = y;
  }
}

whenDomReady().then(initialise);
